export default "__VITE_ASSET__84c4a28c__"